<template>
  <a-modal
    :width="1000"
    :title="title"
    :visible="innerVisible"
    @cancel="handleCancel"
    :cancelText="$t('button.close')"
    :okButtonProps="{style:{display:'none'}}"
  >
    <a-alert type="info" showIcon style="margin-bottom: 16px;">
      <template slot="message">
        <span>{{$t('tip.selected')}}</span>
        <a style="font-weight: 600;padding: 0 4px;">{{ selectedRowKeys.length }}</a>
        <span>{{$t('tip.term')}}</span>
        <template v-if="selectedRowKeys.length>0">
          <a-divider type="vertical"/>
          <a @click="handleClearSelection">{{$t('button.clearSelection')}}</a>
          <a-divider type="vertical"/>
          <a @click="handleRevertBatch">{{$t('button.batchRestore')}}</a>
          <a-divider type="vertical"/>
          <a @click="handleDeleteBatch">{{$t('button.batchDelete')}}</a>
        </template>
      </template>
    </a-alert>

    <a-table
      ref="table"
      rowKey="id"
      size="middle"
      bordered
      :columns="columns"
      :loading="loading"
      :dataSource="dataSource"
      :pagination="false"
      :rowSelection="{selectedRowKeys, onChange: handleTableSelectChange}"
    >
      <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
      <!-- 显示头像 -->
      <template slot="avatarslot" slot-scope="text, record, index">
        <div class="anty-img-wrap">
          <a-avatar shape="square" :src="url.getAvatar(record.avatar)" icon="user"/>
        </div>
      </template>

      <span slot="action" slot-scope="text, record">
        <a @click="handleRevert([record.id])"><a-icon type="redo"/> {{$t('button.restoreUser')}}</a>
        <a-divider type="vertical"/>
        <a @click="handleDelete([record.id])"><a-icon type="delete"/>{{ $t('button.deleteCompletely')}}</a>
      </span>
    </a-table>

  </a-modal>
</template>

<script>
  import { putAction,deleteAction,getFileAccessHttpUrl } from "@/api/manage"

  // 高度封装的请求，请务必使用 superRequest.call(this,{}) 的方式调用
  function superRequest(options) {
    this.loading = !!options.loading
    options.promise.then(res => {
      if (res.success && typeof options.success === 'function') {
        options.success(res)
      } else {
        throw new Error(res.message)
      }
    }).catch(e => {
      console.error('查询已删除的用户失败：', e)
      this.$message.warning('查询已删除的用户失败：' + (e.message || e))
    }).finally(() => {
      this.loading = false
    })
  }

  export default {
    name: 'UserRecycleBinModal',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        title: '用户回收站',
        loading: false,
        innerVisible: false,
        selectedRowKeys: [],
        dataSource: [],
        columns: [
          { title: '#', align: 'center', key: 'rowIndex', width: 80, customRender: (t, r, i) => i + 1 },
          { 
            slotName: 'tableHeader.userAccount',
            // title: '账号', 
            align: 'center', dataIndex: 'username',
            scopedSlots: { title: 'tableHeader.userAccount'} },
          { 
            slotName: 'tableHeader.userName',
            // title: '姓名', 
            align: 'center', dataIndex: 'realname',
            scopedSlots: { title: 'tableHeader.userName'} },
          { 
            slotName: 'tableHeader.image',
            // title: '头像', 
            align: 'center', dataIndex: 'avatar', scopedSlots: { customRender: 'avatarslot', title: 'tableHeader.image' } },
          { 
            slotName: 'tableHeader.department',
            // title: '部门', 
            align: 'center', dataIndex: 'orgCode',
            scopedSlots: { title: 'tableHeader.department'} },
          { 
            slotName: 'tableHeader.operation',
            // title: '操作', 
            align: 'center', dataIndex: 'action', width: 200, scopedSlots: { customRender: 'action', title: 'tableHeader.operation' } }
        ],
        url: {
          getAvatar: (path) => getFileAccessHttpUrl(`${path}`),
          // 回收站操作，get = 获取列表；put = 取回；delete = 彻底删除
          recycleBin: '/mtc-auth/sys/user/recycleBin',
          putRecycleBin: '/mtc-auth/sys/user/putRecycleBin',
          deleteRecycleBin: '/mtc-auth/sys/user/deleteRecycleBin',
        },
      }
    },
    watch: {
      visible: {
        immediate: true,
        handler(val) {
          if (val) {
            this.loadData()
          }
          this.innerVisible = val
        }
      },
      innerVisible(val) {
        this.$emit('update:visible', val)
      },
    },
    methods: {
      loadData() {
        superRequest.call(this, {
          loading: true,
          promise: this.$http.get(this.url.recycleBin),
          success: res => this.dataSource = res.result
        })
      },
      handleOk() {
        this.loadData()
        this.$emit('ok')
      },
      handleCancel() {
        this.innerVisible = false
      },
      // $t('label.restoreUser')
      handleRevert(userIds) {
        let this_ = this
        this.$confirm({
          title: this_.$t('tip.restoreUser'),
          content: `${this_.$t('tip.areYouSureRestore')} ${userIds.length} ${this_.$t('tip.users')}？`,
          centered: true,
          onOk: () => {
            putAction(this.url.putRecycleBin,{userIds:userIds.join(',')}).then((res)=>{
              if(res.success){
                this.handleOk()
                this.handleClearSelection()
                this.$message.success(`${this_.$t('tip.restore')} ${userIds.length} ${this_.$t('tip.users')}${this_.$t('tip.successfully')}`)
              }
            })
          }
        })
      },
      // 彻底删除用户
      handleDelete(userIds) {
        let this_ = this
        this.$confirm({
          title: `${this_.$t('tip.deleteCompletely')}${this_.$t('tip.users')}`,
          content: (<div>
            <p>{this_.$t('tip.areYouSureDelete')} {userIds.length} {this_.$t('tip.users')}？</p>
            <p style="color:red;">{this_.$t('tip.notePleaseBeCarefulItCannotBeRecoveredAfterDeletion')}</p>
          </div>),
          centered: true,
          onOk: () => {
            var that = this;
            deleteAction(that.url.deleteRecycleBin, {userIds: userIds.join(',')}).then((res) => {
              if (res.success) {
                this.loadData()
                this.handleClearSelection()
                this.$message.success(`${this_.$t('tip.delete')} ${userIds.length} ${this_.$t('tip.users')}${this_.$t('tip.successfully')}`)
              } else {
                that.$message.warning(res.message);
              }
            });
          },
        })
      },
      handleRevertBatch() {
        this.handleRevert(this.selectedRowKeys)
      },
      handleDeleteBatch() {
        this.handleDelete(this.selectedRowKeys)
      },
      handleClearSelection() {
        this.handleTableSelectChange([], [])
      },
      handleTableSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectionRows = selectionRows
      },
    }
  }
</script>

<style lang="less" scoped></style>